import React, {useEffect, useRef, useState} from "react";
import {Col, Row} from "reactstrap";
import {Button as SementicBtn} from "semantic-ui-react";
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import './style.css';
import * as actionCreators from "../../../store/Action";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import {useFaceDetection} from "react-use-face-detection";
import FaceDetection from '@mediapipe/face_detection';
import * as faceapi from 'face-api.js';

const WebCameraWithFR = (props) => {
  const [pending,setPending] = useState(0);
  const [isOpen,setIsOpen] = useState(props.isOpen);
  const [isIOS,setIsIOS] = useState(false);
  // const [detected,setDetected] = useState(false);
  // const [warningMsg,setWarningMsg] = useState("");
  // const imgRef = useRef();
  const { imgRef, boundingBox, isLoading, detected, facesDetected } = useFaceDetection({
    faceDetectionOptions : {
      model: 'short'
    },
    faceDetection: new FaceDetection.FaceDetection({
      locateFile: (file) => {
        return `/face_detection/${file}`
      },
    }),
  });

  const screenShotHandler = () => {
    /*if (!detected) {
      common.notifyMessage("Face detection failed!");
      return;
    }*/
    props.imageUpload(props.screenshot);
  }

  const retakeImageHandler = () => {
    props.retakeImage(true);
  }

  // console.log("isLoading" , isLoading);
  // console.log("Detected" , detected);

  /*const detectFaces = async () => {
    await faceapi.nets.tinyFaceDetector.load('/models'); // load the face detection model
    await faceapi.nets.faceLandmark68Net.load('/models');
    let detections = await faceapi.detectAllFaces(imgRef.current, new faceapi.TinyFaceDetectorOptions({scoreThreshold: 0.3})).withFaceLandmarks();
    console.log(detections);
    if (detections.length === 0) {
      setDetected(false);
      setWarningMsg("Face detection failed");
      setTimeout(() => {
        setPending(1)
      }, 1200);
    } else if (detections.length === 1) {
      setDetected(true);
      setTimeout(() => {
        setPending(1)
      }, 1200);
    } else if (detections.length > 1) {
      setDetected(false);
      setWarningMsg("Multiple faces detected. Please try with single face");
      setTimeout(() => {
        setPending(1)
      }, 1200);
    }
  }*/


  useEffect(()=>{
    if (!isLoading) setPending(1);
    const userAgent = navigator.userAgent;
    if (userAgent.indexOf("iOS") !== -1 || userAgent.indexOf("Mac") !== -1) {
      setTimeout(()=>{
        setPending(1);
        setIsIOS(true);
      },1000)
    }
    // return () => clearTimeout(timeOutId);
    // detectFaces();

    /*let timeOutId = setTimeout(() => {
      setPending(1);
    },1200);*/

    // return () => console.log(imgRef.current);
  },[isLoading]);

  // console.log("detected",detected)
  // console.log("pending",pending)
  // console.log("isIOS",isIOS)
  if (pending === 1 && detected){
    screenShotHandler();
  }

  if (pending === 1 && isIOS) {
    screenShotHandler();
  }

  return (
    <MDBModal isOpen={isOpen} toggle={() => {}} size="md" className={"user-verification-modal guest-reg-form"}>
      <MDBModalHeader style={{padding: '5px'}}>Profile Picture Verification</MDBModalHeader>
      <MDBModalBody>
        <img src={props.screenshot} style={{
          width: '200px',
          height: '150px',
          objectFit: 'scale-down',
          // border: '1px #9a9a9a dotted',
          boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.161)',
        }}
        ref={imgRef}
        />
        {pending === 0 && <div className={'d-flex align-items-center justify-content-center fr-spinner mt-3'}>
          <div className="ui segment spinner-div" id="data-fetch-loader" >
            <div className="ui active inverted dimmer">
              <div className="ui text loader">
              </div>
            </div>
          </div>
        </div>}
        {pending === 1 && <Row>
          {/*{detected && <p className={'success-text'}>Face detected successfully</p>}*/}
          {!detected && <p className={'warning-text'}>Face detection failed</p>}
          <Col className={'align-center'}>
            {!detected && <SementicBtn style={{width: "25%"}} className={"retry-btn"}
                                                     onClick={retakeImageHandler}
            >Retry</SementicBtn>}
            {/*{detected && <SementicBtn style={{width: "30%"}} className="px-5 search-visitor-btn"
                                      onClick={screenShotHandler}
            >Confirm</SementicBtn>}*/}
          </Col>
        </Row>}
      </MDBModalBody>
    </MDBModal>
  );

}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  all_available_card: state.reception_SheduleMeetingReducer.all_available_card,
});

const mapDispatchToProps = (dispatch) => {
  return {
    imageUploaderHandler: (image) => dispatch(actionCreators.imageUploaderHandler(image)),
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // all available cards
    receptionAllAvailableCardHandler: (data) => dispatch(actionCreator.receptionAllAvailableCardHandler(data))
  }
};


export default connect(mapStateToProps, mapDispatchToProps)(WebCameraWithFR);
